import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import { FunnelInterface } from 'modules/funnels/funnel/types/funnel-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useFunnel(id?: FunnelId) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, FunnelInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: funnel, mutate: mutateFunnel } = useSWR(() => {
    if (user && id) {
      return `${FUNNELS_API}/${id}`
    }
    return null
  }, fetcher)

  return { funnel, mutateFunnel }
}
